import {pushEvent} from "tracking/core/dispatcher";
import {EVENT_NAMES} from "tracking/core/eventNames";
import {
    FormBeginPayload,
    FormSubmitErrorPayload,
    FormSubmitPayload,
    NewsletterSubscribePayload,
    PushOptions
} from "../core/types";

export const FORM_TYPES = {
    ORDER: 'Publication Order Form',
    AMOUNT_INCREASE: 'Amount Increase Form',
    PERIOD_EXTENSION: 'Period Increase Form',
    COREFORMS: 'Coreforms',
} as const;

export function dataLayerFormBegin(
    formId: string | number | null,
    formName: string | null,
    formType?: string | null,
    options?: PushOptions
) {
    const payload: FormBeginPayload = {
        form_id: formId != null ? String(formId) : undefined,
        form_name: formName ?? undefined,
        form_type: formType ?? undefined,
    };
    pushEvent(EVENT_NAMES.FORM_BEGIN, payload, options);
}

export function dataLayerFormSubmit(
    formId: string | number | null,
    formName: string | null,
    formType?: string | null,
    options?: PushOptions
) {
    const payload: FormSubmitPayload = {
        form_id: formId != null ? String(formId) : undefined,
        form_name: formName ?? undefined,
        form_type: formType ?? undefined,
    };
    pushEvent(EVENT_NAMES.FORM_SUBMIT, payload, options);
}

export function dataLayerFormSubmitError(
    formId: string | number | null,
    formName: string | null,
    formType: string | null | undefined,
    errorMessage: string | null,
    options?: PushOptions
) {
    const payload: FormSubmitErrorPayload = {
        form_id: formId != null ? String(formId) : undefined,
        form_name: formName ?? undefined,
        form_type: formType ?? undefined,
        error_message: errorMessage ?? undefined,
    };
    pushEvent(EVENT_NAMES.FORM_SUBMIT_ERROR, payload, options);
}

export function dataLayerNewsletterSubscribe(
    options?: PushOptions
) {
    // Push with an explicit empty payload and rely on dispatcher to include empty object
    // via FORCE_EMPTY_PAYLOAD_EVENTS so that dataLayer contains newsletter_subscribe: {}
    pushEvent(EVENT_NAMES.NEWSLETTER_SUBSCRIBE, {} as NewsletterSubscribePayload, options);
}
